import React, { useState, useEffect } from 'react';
import { FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { OnChangeCallback } from '../../util/UtilityTypes'

interface NullableIntInputCheckboxTextProps {
    title: string
    name: string
    value?: number | null
    defaultValue: number
    checkboxTitle: string
    disabled?: boolean
    invalid?: boolean
    invalidFeedback?: string
    onChange: OnChangeCallback<number | null | undefined>
}

const NullableIntInputCheckboxText: React.FC<NullableIntInputCheckboxTextProps> = (props) => {
    const [previous, setPrevious] = useState(Number.isInteger(props.value) ? props.value ?? undefined : props.defaultValue)
    const [checked, setChecked] = useState<boolean>(!Number.isInteger(props.value) ? true : false);

    useEffect(() => {
        if (props.value === null) {
            setChecked(true)
        }
    }, [props.value])

    const toggle = (shouldBeChecked: boolean) => {
        setChecked(shouldBeChecked);
        const value = shouldBeChecked ? null : previous;

        props.onChange(props.name, value)
    }

    const updateValue: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        let value: number | null | undefined = e.target.valueAsNumber
        if (isNaN(value)) {
            value = undefined
        }

        setPrevious(value)
        props.onChange(props.name, value)
    }

    return (
        <FormGroup>
            <Label for={props.name}>{props.title}</Label>
            <Input
                className="md-w-50 lg-w-25"
                type="number"
                name={props.name}
                id={props.name}
                min="0"
                step="1"
                pattern="[0-9]"
                value={props.value ?? ''}
                onChange={(e) => updateValue(e)}
                disabled={props.disabled || checked}
                invalid={props.invalid}
                onWheel={(e) => (e.target as HTMLInputElement).blur()}
            />
            <FormFeedback>{props.invalidFeedback}</FormFeedback>
            <FormGroup check>
                <Label>
                    <Input
                        type="checkbox"
                        name={`${props.name}Check2`}
                        id={`${props.name}Check2`}
                        disabled={props.disabled}
                        checked={checked}
                        onChange={(e) => toggle(e.target.checked)}
                    />
                    {props.checkboxTitle}
                </Label>
            </FormGroup>
        </FormGroup>
    )
}

export default NullableIntInputCheckboxText;
